import React from 'react';
import PropTypes from 'prop-types';
import { Title } from 'smartsuite-ui';
import {
    getNumberOfColumnsFromPanelConfig,
    getResponsiveLayoutMode,
    isLandscape,
} from '../dashboardUtils';
import { responsiveLayouts } from '../../shared/constants/constants';

// eslint-disable-next-line complexity
function getPanelClassName(layoutSettings, printViewMode) {
    const layoutSettingsValue = layoutSettings ?? {};
    let panelClassName = 'print-grid-panel';

    if (isLandscape(printViewMode)) {
        panelClassName += ' print-grid-panel--tablet';

        if (layoutSettingsValue.tablet?.isFullWidth) {
            panelClassName += ' print-grid-panel--full-width';
        }

        if (layoutSettingsValue.tablet?.isCentered) {
            panelClassName += ' print-grid-panel--centered';
        }
    }

    return panelClassName;
}

function getWidgetDimensions(panel, widgetsToUse, printViewMode) {
    const responsiveLayout = isLandscape(printViewMode)
        ? responsiveLayouts.tablet
        : responsiveLayouts.mobile;

    const layoutMode = getResponsiveLayoutMode(responsiveLayout);

    const numberOfColumns =
        widgetsToUse.length === 1
            ? 1
            : getNumberOfColumnsFromPanelConfig(panel, layoutMode);

    /* eslint-disable indent */
    const widgetWidth = `calc(99% / ${numberOfColumns})`;

    const widgetHeight = `calc(99% / ${Math.ceil(
        widgetsToUse.length / numberOfColumns
    )})`;
    /* eslint-enable indent */

    return { widgetWidth, widgetHeight };
}

export default function ExportWidgetPanel(props) {
    function renderPanel() {
        const { widgetWidth, widgetHeight } = getWidgetDimensions(
            props.panel,
            props.panelWidgets,
            props.printViewMode
        );

        return (
            <div
                className={getPanelClassName(
                    props.panel.layoutSettings,
                    props.printViewMode
                )}
            >
                {props.panel.header && (
                    <Title cssClassModifiers={['size-medium']}>
                        {props.panel.header}
                    </Title>
                )}
                {props.renderWidgets(
                    props.panelWidgets,
                    props.panel.id,
                    widgetWidth,
                    widgetHeight
                )}
            </div>
        );
    }

    function renderTab(tab) {
        const panelHeader = props.panel.header
            ? `${props.panel.header} - `
            : '';
        const tabWidgets = props.panelWidgets.filter(
            (widget) => widget.tabId === tab.id
        );

        const { widgetWidth, widgetHeight } = getWidgetDimensions(
            props.panel,
            tabWidgets,
            props.printViewMode
        );

        return (
            <div
                key={tab.id}
                className={getPanelClassName(
                    props.panel.layoutSettings,
                    props.printViewMode
                )}
            >
                <Title cssClassModifiers={['size-medium']}>
                    {`${panelHeader}${tab.label}`}
                </Title>
                {props.renderWidgets(
                    tabWidgets,
                    props.panel.id,
                    widgetWidth,
                    widgetHeight
                )}
            </div>
        );
    }

    return !props.panel.tabs ? renderPanel() : props.panel.tabs.map(renderTab);
}

ExportWidgetPanel.propTypes = {
    panel: PropTypes.instanceOf(Object).isRequired,
    panelWidgets: PropTypes.instanceOf(Array).isRequired,
    printViewMode: PropTypes.string.isRequired,
    renderWidgets: PropTypes.func.isRequired,
};
